import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../App';
import api from '../api';
import DataTable from '../components/DataTable';
import { rolde } from '../yetki';

const ISLEM_RENK = {
  EKLE: '#1b5e20', GUNCELLE: '#1565c0', SIL: '#b71c1c', DURUM_DEGIS: '#e65100',
  GIRIS: '#4a148c', SIFRE_DEGIS: '#880e4f', YENILE: '#006064',
  BELGE_GUNCELLE: '#f57f17', ONAYLA: '#1b5e20',
};

export default function IslemLog() {
  const { kullanici } = useContext(AuthContext);
  const [veriler, setVeriler] = useState([]);
  const [toplam, setToplam] = useState(0);
  const [sayfa, setSayfa] = useState(1);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [secili, setSecili] = useState(null);
  const [filtre, setFiltre] = useState({ tablo: '', islem_tipi: '', baslangic: '', bitis: '' });

  useEffect(() => { yukle(); }, [sayfa]); // eslint-disable-line

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const params = new URLSearchParams({ sayfa, limit: 200, ...filtre });
      const r = await api.get(`/tanimlar/islem-log?${params}`);
      setVeriler(r.data.veriler);
      setToplam(r.data.toplam);
    } catch (err) {
      if (err.response?.status === 403) return;
    } finally { setYukleniyor(false); }
  };

  const ara = (e) => { e.preventDefault(); setSayfa(1); yukle(); };

  if (!rolde(kullanici, 'admin', 'mudur')) {
    return <div className="alert alert-error">Bu sayfaya erişim yetkiniz yok.</div>;
  }

  const TABLOLAR = ['ftbl_ruhsat_hareketleri', 'tk_tblteksicil', 'tbl_tut_onkontrol', 'tbl_tut_sonkontrol', 'tbl_tut_zabitakontrol', 'tbl_tut_beyan', 'tbl_tut_tespit', 'tbl_basvuru_belgeler', 'tbl_ruhsat_ek', 'tbl_ruhsat_yenileme', 'kullanicilar', 'tbl_const', 'tbl_nace_kodu'];
  const ISLEMLER = ['EKLE', 'GUNCELLE', 'SIL', 'DURUM_DEGIS', 'GIRIS', 'SIFRE_DEGIS', 'YENILE', 'BELGE_GUNCELLE', 'ONAYLA'];

  const fmt = d => d ? new Date(d).toLocaleString('tr-TR') : '';

  const columns = [
    {
      key: 'islem_zamani', label: 'Tarih / Saat', width: '140px',
      render: (v, r) => <span style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>{fmt(v || r.islem_tarihi)}</span>,
      exportValue: r => fmt(r.islem_zamani || r.islem_tarihi),
    },
    {
      key: 'kullanici_adi', label: 'Kullanıcı',
      render: (v, r) => (
        <div>
          <div style={{ fontSize: '12px', fontWeight: '600' }}>{v || '—'}</div>
          <div style={{ fontSize: '11px', color: '#888' }}>{r.kullanici_kodu}</div>
        </div>
      ),
      exportValue: r => r.kullanici_adi || r.kullanici_kodu,
    },
    {
      key: 'islem_tipi', label: 'İşlem', width: '110px',
      render: (v, r) => {
        const tip = v || r.islem_turu;
        return <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: '#f5f5f5', color: ISLEM_RENK[tip] || '#333', fontWeight: '700' }}>{tip}</span>;
      },
      exportValue: r => r.islem_tipi || r.islem_turu,
    },
    {
      key: 'tablo_adi', label: 'Tablo', width: '180px',
      render: v => <span style={{ fontSize: '11px', fontFamily: 'monospace', color: '#555' }}>{v}</span>,
      exportValue: r => r.tablo_adi,
    },
    {
      key: 'kayit_id', label: 'Kayıt ID', width: '70px',
      render: v => <span style={{ fontSize: '12px', color: '#888' }}>{v || '—'}</span>,
      exportValue: r => r.kayit_id,
    },
    {
      key: 'aciklama', label: 'Açıklama',
      render: v => <span style={{ fontSize: '12px', display: 'block', maxWidth: '260px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v || '—'}</span>,
      exportValue: r => r.aciklama,
    },
    {
      key: 'ip_adresi', label: 'IP', width: '110px',
      render: v => <span style={{ fontSize: '11px', fontFamily: 'monospace', color: '#888' }}>{v || '—'}</span>,
      exportValue: r => r.ip_adresi,
    },
    {
      key: '_detay', label: 'Detay', width: '80px', sortable: false, filterable: false,
      render: (_, r) => (r.eski_deger || r.yeni_deger) ? (
        <button className="btn btn-outline btn-xs" onClick={e => { e.stopPropagation(); setSecili(r); }}>Görüntüle</button>
      ) : null,
    },
  ];

  return (
    <div>
      <h2 style={{ color: '#1a237e', marginBottom: '20px' }}>📋 İşlem Logları</h2>

      <div className="card" style={{ marginBottom: '16px' }}>
        <form onSubmit={ara}>
          <div className="form-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))' }}>
            <div className="form-group">
              <label>Tablo</label>
              <select value={filtre.tablo} onChange={e => setFiltre({ ...filtre, tablo: e.target.value })}>
                <option value="">Tümü</option>
                {TABLOLAR.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>İşlem Tipi</label>
              <select value={filtre.islem_tipi} onChange={e => setFiltre({ ...filtre, islem_tipi: e.target.value })}>
                <option value="">Tümü</option>
                {ISLEMLER.map(i => <option key={i} value={i}>{i}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Başlangıç</label>
              <input type="date" value={filtre.baslangic} onChange={e => setFiltre({ ...filtre, baslangic: e.target.value })} />
            </div>
            <div className="form-group">
              <label>Bitiş</label>
              <input type="date" value={filtre.bitis} onChange={e => setFiltre({ ...filtre, bitis: e.target.value })} />
            </div>
            <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
              <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>🔍 Filtrele</button>
            </div>
          </div>
        </form>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">İşlem Kayıtları</span>
          <span style={{ fontSize: '12px', color: '#888' }}>Toplam: {toplam} kayıt</span>
        </div>

        <DataTable
          columns={columns}
          data={veriler}
          filename="islem-loglari"
          pdfTitle="İşlem Logları — Ünye Belediyesi"
          loading={yukleniyor}
          rowKey="id"
        />

        {toplam > 200 && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', padding: '16px' }}>
            <button className="btn btn-outline btn-sm" onClick={() => setSayfa(p => Math.max(1, p - 1))} disabled={sayfa === 1}>← Önceki</button>
            <span style={{ padding: '6px 12px', fontSize: '13px' }}>{sayfa} / {Math.ceil(toplam / 200)}</span>
            <button className="btn btn-outline btn-sm" onClick={() => setSayfa(p => p + 1)} disabled={sayfa >= Math.ceil(toplam / 200)}>Sonraki →</button>
          </div>
        )}
      </div>

      {secili && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setSecili(null)}>
          <div className="modal" style={{ maxWidth: '700px' }}>
            <div className="modal-header">
              <span className="modal-title">İşlem Detayı — {secili.islem_tipi || secili.islem_turu} | {secili.tablo_adi}</span>
              <button className="modal-close" onClick={() => setSecili(null)}>×</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', padding: '4px' }}>
              {secili.eski_deger && (
                <div>
                  <strong style={{ fontSize: '12px', color: '#b71c1c' }}>📤 Eski Değer</strong>
                  <pre style={{ fontSize: '11px', background: '#fff3e0', padding: '10px', borderRadius: '6px', overflow: 'auto', maxHeight: '300px', marginTop: '6px' }}>
                    {JSON.stringify(typeof secili.eski_deger === 'string' ? JSON.parse(secili.eski_deger) : secili.eski_deger, null, 2)}
                  </pre>
                </div>
              )}
              {secili.yeni_deger && (
                <div>
                  <strong style={{ fontSize: '12px', color: '#1b5e20' }}>📥 Yeni Değer</strong>
                  <pre style={{ fontSize: '11px', background: '#e8f5e9', padding: '10px', borderRadius: '6px', overflow: 'auto', maxHeight: '300px', marginTop: '6px' }}>
                    {JSON.stringify(typeof secili.yeni_deger === 'string' ? JSON.parse(secili.yeni_deger) : secili.yeni_deger, null, 2)}
                  </pre>
                </div>
              )}
            </div>
            <div style={{ padding: '12px', fontSize: '12px', color: '#666', borderTop: '1px solid #eee', marginTop: '8px' }}>
              Açıklama: {secili.aciklama || '—'} | IP: {secili.ip_adresi || '—'}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
